"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var scrollTo_1 = require("spry-react/ScrollTo/scrollTo");
var errorDisplayList_1 = require("./errorDisplayList");
var react_1 = require("react");
function ErrorDisplayListScrollable(props) {
    var focus = react_1.useRef(function () { });
    var focusAfterScrolling = function () {
        props.doneScrolling();
        focus.current();
    };
    var hasErrorsAndWarnings = props.errors.errors.some(function (x) { return x.isWarning; }) && props.errors.errors.some(function (x) { return !x.isWarning; });
    var errors = props.errors.errors.map(function (x) {
        return (React.createElement("div", null,
            hasErrorsAndWarnings &&
                React.createElement("span", { className: x.isWarning ? 'warning-icon' : 'exclamation-circle-icon' }),
            React.createElement("span", { className: x.isWarning ? 'validation-warning' : 'validation-error' }, x.errorMessage)));
    });
    var allValidationsAreWarnings = !props.errors.errors.some(function (x) { return !x.isWarning; });
    return React.createElement(React.Fragment, null,
        React.createElement(scrollTo_1.ScrollTo, { shouldScroll: props.errors.shouldScroll, doneScrolling: focusAfterScrolling }),
        React.createElement(errorDisplayList_1.ErrorDisplayList, { errors: errors, focusRef: focus, allValidationsAreWarnings: allValidationsAreWarnings }));
}
exports.ErrorDisplayListScrollable = ErrorDisplayListScrollable;
function getErrorMessages(errors) {
    return errors.map(function (e) { return e.errorMessage; });
}
exports.getErrorMessages = getErrorMessages;
function doneScrollingErrors(errors) {
    return __assign(__assign({}, errors), { shouldScroll: false });
}
exports.doneScrollingErrors = doneScrollingErrors;
function scrollToErrors(errors) {
    return {
        errors: errors,
        shouldScroll: true
    };
}
exports.scrollToErrors = scrollToErrors;
function getErrorMessage(errorList, key) {
    return errorList.errors.filter(function (e) { return e.propertyName.toLowerCase() === key.toLowerCase(); }).map(function (e) { return e.errorMessage; }).join('\r\n');
}
exports.getErrorMessage = getErrorMessage;
exports.EmptyErrors = { errors: [], shouldScroll: false };
